// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"Breadcrumbs_listContainer__TsMC1","dot":"Breadcrumbs_dot__tLFFf","dots":"Breadcrumbs_dots__I1MkZ"};